import { gql } from "@apollo/client";

/**
 * Data of the "Network scan" tab in the node detail panel (IBM-1039).
 * `networkScan` is what is documented on this node (prefills the form);
 * `effectiveNetworkScan` on the node's system / asset location is what
 * applies (own scan first, otherwise the nearest documented ancestor) and
 * only exists for SYSTEM and ASSET nodes. `canDocumentNetworkScan` already
 * covers node type, resource and write access — no role check in the UI.
 * Deliberately without nodeType/pathNodes: the panel header query holds them.
 * Only sent while REACT_APP_ENABLE_SLA is on.
 */
export const InstalledBaseNodeNetworkScan = gql`
    query InstalledBaseNodeNetworkScan($id: ID!) {
        installedBaseNode(id: $id) {
            id
            assetCount
            canDocumentNetworkScan
            networkScan {
                state
                scanDate
                userName
            }
            assetLocation {
                id
                effectiveNetworkScan {
                    state
                    scanDate
                    source {
                        installedBaseNodeId
                        nodeTypeKey
                        name
                    }
                }
            }
            system {
                id
                effectiveNetworkScan {
                    state
                    scanDate
                    source {
                        installedBaseNodeId
                        nodeTypeKey
                        name
                    }
                }
            }
        }
    }
`;
